//@ts-nocheck
// src/components/ReplyModal.tsx
import React, { useState } from 'react';
import Modal from '../../../components/bootstrap/Modal';
import Button from '../../../components/bootstrap/Button';
import {
  CardActions,
  CardBody,
  CardHeader,
  CardLabel,
  CardTitle,
  CardSubTitle,
} from '../../../components/bootstrap/Card';
import userState from '../../../shared/mobx/user-state';

const ReplyModal = ({ isOpen, onClose, contact }) => {
  const [replyMessage, setReplyMessage] = useState(''); // State to store reply message
  const [isLoading, setIsLoading] = useState(false); // State for loading
  const [isSuccess, setIsSuccess] = useState(false); // State for success feedback

  // Clear message when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setReplyMessage('');
      setIsLoading(false);
      setIsSuccess(false);
    }
  }, [isOpen]);

  const handleSendReply = async () => {
    if (!replyMessage.trim()) {
      return; // Don't send if message is empty
    }
    
    setIsLoading(true); // Start loading
    try {
      // Logic for sending reply (e.g., API call)
      console.log(`Sending reply to ${contact.email}: ${replyMessage}`);

      const response = await userState.contactUsReply(contact.email, contact.full_name, replyMessage, contact.id);
      
      // Check if the response indicates success
      if (response && response.status === true) {
        console.log('Reply sent successfully');
        setReplyMessage(''); // Clear the message after successful send
        setIsSuccess(true); // Show success state
        
        // Add a small delay to ensure message clearing is visible
        setTimeout(() => {
          onClose(); // Close modal after successful send
        }, 1000);
      } else {
        console.error('Failed to send reply');
        // Don't clear message on failure, let user try again
      }
      
    } catch (error) {
      console.error('Error sending reply:', error);
      // Don't clear message on error, let user try again
    } finally {
      setIsLoading(false); // Stop loading
    }
  };


  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={onClose}
      titleId="Reply to Contact Message"
      isStaticBackdrop={true}
      isCentered={true}
      isAnimation={true}
      title="Reply to Contact Message"
      onClose={onClose}
      size={"lg"} // Larger size for modal
    >
      <>
        <CardHeader>
          <CardLabel icon="Reply" iconColor="info">
            <CardTitle tag="div" className="h5">
              Reply to Contact Message
            </CardTitle>
            <CardSubTitle tag="div" className="h6">
              Write and send a reply to the selected message
            </CardSubTitle>
          </CardLabel>
        </CardHeader>
        <CardBody >
          {/* Section 1: Display Email */}
          <div className="mb-4">
            <p style={{ color: 'black' }}>
              <strong>Email:</strong> {contact.email}
            </p>
          </div>

          {/* Section 2: Reply Textbox */}
          <div >
            <label>
              <strong>Reply Message:</strong>
            </label>
            <textarea
              className="form-control"
              value={isSuccess ? 'Reply sent successfully!' : replyMessage}
              onChange={(e) => setReplyMessage(e.target.value)} // Update reply message
              rows={5}
              placeholder={isSuccess ? 'Reply sent successfully!' : "Write your reply here..."}
              disabled={isSuccess} // Disable textarea when success
              style={{
                padding: '10px',
                border: isSuccess ? '1px solid #28a745' : '1px solid #ddd',
                borderRadius: '5px',
                minHeight: '100px',
                whiteSpace: 'pre-wrap', // Preserve newlines and spaces
                wordWrap: 'break-word', // Allow word wrapping
                backgroundColor: isSuccess ? '#d4edda' : '#f9f9f9', // Green background on success
                maxHeight: '300px', // Maximum height for reply box
                overflowY: 'auto', // Scrollable if content exceeds max height
              }}
            />
          </div>
        </CardBody>

        <CardActions className="text-end mb-3">
          <Button
            type="button"
            color={isSuccess ? "success" : "primary"}
            className="auth-btn"
            style={{ padding: '10px 20px' }}
            onClick={handleSendReply} // Call function to send reply
            disabled={isLoading || !replyMessage.trim() || isSuccess} // Disable when loading, empty, or success
            isLoading={isLoading} // Show loading spinner
          >
            {isLoading ? 'Sending...' : isSuccess ? 'Sent!' : 'Send Reply'}
          </Button>
          <Button
            type="button"
            style={{
              width: '100px',
              padding: '10px'
            }}
            onClick={() => onClose(false)}
            className="ms-2 me-4 auth-btn"
            disabled={isLoading} // Disable close button during loading
          >
            Close
          </Button>
        </CardActions>
      </>
    </Modal>
  );
};

export default ReplyModal;
